export const siteSettings = {
  name: "FluidXFinance",
  link: "https://fluidxfinex.net",
  email: "support@fluidxfinex.net",
  appLink: "https://app.fluidxfinex.net",
};
